import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getTranslations,
  getPreflightReport,
  getAdMaterial
} from "../../redux/actions";

const useDetails = props => {
  const [asideHidden, setAsideHidden] = useState(false);
  const dispatch = useDispatch();
  const preflightReport = useSelector(state => state.preflightReport);
  const admaterial = useSelector(state => state.admaterial);

  useEffect(() => {
    console.log("*** Mounting Details ***");
    dispatch(getAdMaterial());
    dispatch(getTranslations("en", false)), [];
  }, []);
  
  useEffect(() => {
    if (admaterial) {
      console.log("*** Loading Report for admaterial: " + admaterial.id + " ***");
      dispatch(getPreflightReport({ id: admaterial.id }));
    }
  }, [admaterial]);

  return { asideHidden, preflightReport, admaterial, setAsideHidden };
};

export default useDetails;



// WEBPACK FOOTER //
// ./src/components/Details/useDetails.js